import CountDownTrigger from "./../CountDownTrigger.js";

export default class GeneralEventHandler {
    /**
     * @returns this
     */
    static make() {
        return new this;
    }
    /**
     * @returns this
     */
    addCountDownTimer() {
        let header = jQuery('body header');
        let countDownTimer = header.find('.countdown-timer');
        let countDownTo = String(countDownTimer.data('countdown-to'));
        if (countDownTimer.data('show')) {
            let countDownTrigger = new CountDownTrigger({
                Y: parseInt(countDownTo.substr(0, 4)),
                m: parseInt(countDownTo.substr(5, 2)),
                d: parseInt(countDownTo.substr(8, 2)),
                H: parseInt(countDownTo.substr(11, 2)),
                i: parseInt(countDownTo.substr(14, 2)),
                s: parseInt(countDownTo.substr(17, 2)),
            });
            countDownTrigger.start();
        }
        return this;
    }
    /**
     * @returns this
     */
    addTextSliderAnimation() {
        let slideIndex = 0;
        showSlides();
        function showSlides() {
            let slides = jQuery('.slides');
            slides.each(function() {
                jQuery(this).fadeOut(2000);
            });
            slideIndex++;
            if (slideIndex > slides.length) {slideIndex = 1}
            jQuery(slides[slideIndex-1]).fadeIn(2000);
            setTimeout(showSlides, 5000);
        }
        return this;
    }
    /**
     * @returns this
     */
    showSearchFieldAndSetFocus() {
        // Set focus on the header search input box for quick search
        jQuery('.search-toggle').on('click', function() {
            jQuery(this).hide();
            const $searchFieldWrapper = jQuery('.search-field-wrapper');
            const $searchField = jQuery('.search-field');
            $searchField.val('');
            $searchFieldWrapper.show();
            setTimeout(function() {
                $searchField.focus();

            }, 200);
        });
        return this;
    }
    /**
     * @returns this
     */
    markNewsletterCheckboxDefaultUnchecked() {
        // Mark the newsletter checkbox as unchecked by default during checkout
        jQuery('#noptin_woocommerce_optin_checkbox input').prop('checked', false);
        return this;
    }
    /**
     * @returns this
     */
    collapseCategoryMenuWhenClickedOutside() {
        // Make sure the category menu disappears when we click outside the menu
        let body = jQuery('body');
        body.on('click',function(event){
            if(!jQuery(event.target).is('.cat-nav-trigger')){
                if (body.hasClass('cat-nav-at-navigation-active')) {
                    body.removeClass('cat-nav-at-navigation-active');
                }
            }
        });
        return this;
    }

    /**
     * @returns this
     */
    avoidButtonFlickeringIssueOnFrontpage() {
        // Avoid button flickering CSS issue
        jQuery('.top-boxes .box-title').show();
        return this;
    }

    /**
     * @returns this
     */
    moveCartNoticesElement() {
        jQuery("#cartpops-drawer .cpops-drawer-notices-wrapper").prependTo("#cartpops-drawer .cpops-panel");
        return this;
    }

    /**
     * @returns this
     */
    expandFrontPageImages() {
        jQuery('#image-nav').on('click', function() {
            jQuery(this).closest('.section-group').addClass('expanded-items');
        });
        jQuery(window).on('resize', function() {
            if (jQuery(window).width() >= 600) {
                jQuery('.expanded-items').removeClass('expanded-items');
            }
        });
        return this;
    }

    /**
     * @returns this
     */
    initFrontpageSlider() {
        const wrappers = document.querySelectorAll('.kc-slider-wrapper');

        wrappers.forEach(wrapper => {
            const container = wrapper.querySelector('.kc-slider-container');
            const track = wrapper.querySelector('.kc-slider-track');
            const originalSlides = wrapper.querySelectorAll('.kc-slider-slide');
            const prevBtn = wrapper.querySelector('.kc-prev');
            const nextBtn = wrapper.querySelector('.kc-next');
            const dotsContainer = wrapper.querySelector('.kc-slider-dots');

            if (!track || originalSlides.length <= 1) return;

            const autoplayInterval = parseInt(wrapper.getAttribute('data-interval')) || 8000;

            const firstClone = originalSlides[0].cloneNode(true);
            const lastClone = originalSlides[originalSlides.length - 1].cloneNode(true);

            track.appendChild(firstClone);
            track.insertBefore(lastClone, originalSlides[0]);

            const allSlides = wrapper.querySelectorAll('.kc-slider-slide');
            let currentIndex = 1;
            let startX = 0;
            let currentX = 0;
            let isDragging = false;
            let isMoved = false;
            let autoplayTimer = null;

            track.style.transform = `translateX(-${currentIndex * 100}%)`;

            originalSlides.forEach((_, index) => {
                const dot = document.createElement('button');
                dot.classList.add('kc-dot');
                if (index === 0) dot.classList.add('active');
                dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
                dot.addEventListener('click', () => {
                    if (currentIndex === 0) goToSlide(originalSlides.length, false);
                    if (currentIndex >= allSlides.length - 1) goToSlide(1, false);
                    track.offsetWidth;
                    goToSlide(index + 1);
                    resetAutoplay();
                });
                dotsContainer.appendChild(dot);
            });

            const dots = dotsContainer.querySelectorAll('.kc-dot');

            function updateDots() {
                let dotIndex = currentIndex - 1;
                if (currentIndex === 0) {
                    dotIndex = originalSlides.length - 1;
                } else if (currentIndex === allSlides.length - 1) {
                    dotIndex = 0;
                }
                dots.forEach((dot, index) => {
                    dot.classList.toggle('active', index === dotIndex);
                });
            }

            function goToSlide(index, animate = true) {
                if (index >= allSlides.length) index = allSlides.length - 1;
                if (index < 0) index = 0;

                currentIndex = index;
                if (animate) {
                    track.style.transition = 'transform 0.5s cubic-bezier(0.25, 1, 0.5, 1)';
                } else {
                    track.style.transition = 'none';
                }
                track.style.transform = `translateX(-${currentIndex * 100}%)`;
                updateDots();
            }

            track.addEventListener('transitionend', (event) => {
                if (event.target !== track) return;
                if (event.propertyName !== 'transform') return;

                if (currentIndex === 0) {
                    goToSlide(originalSlides.length, false);
                } else if (currentIndex === allSlides.length - 1) {
                    goToSlide(1, false);
                }
            });

            function startAutoplay() {
                if (document.hidden) return;
                autoplayTimer = setInterval(() => {
                    if (currentIndex >= allSlides.length - 1) {
                        goToSlide(1, false);
                    }
                    track.offsetWidth;
                    goToSlide(currentIndex + 1);
                }, autoplayInterval);
            }

            function resetAutoplay() {
                if (autoplayTimer) {
                    clearInterval(autoplayTimer);
                    startAutoplay();
                }
            }

            if (nextBtn) {
                nextBtn.addEventListener('click', () => {
                    if (currentIndex >= allSlides.length - 1) goToSlide(1, false);
                    track.offsetWidth;
                    goToSlide(currentIndex + 1);
                    resetAutoplay();
                });
            }
            if (prevBtn) {
                prevBtn.addEventListener('click', () => {
                    if (currentIndex === 0) goToSlide(originalSlides.length, false);
                    track.offsetWidth;
                    goToSlide(currentIndex - 1);
                    resetAutoplay();
                });
            }

            document.addEventListener('visibilitychange', () => {
                if (document.hidden) {
                    clearInterval(autoplayTimer);
                } else {
                    if (currentIndex === 0) goToSlide(originalSlides.length, false);
                    if (currentIndex >= allSlides.length - 1) goToSlide(1, false);
                    track.offsetWidth;
                    startAutoplay();
                }
            });

            container.querySelectorAll('img, a').forEach(el => {
                el.addEventListener('dragstart', (e) => e.preventDefault());
            });

            container.querySelectorAll('a').forEach(link => {
                link.addEventListener('click', (e) => {
                    if (isMoved) e.preventDefault();
                });
            });

            function getPositionX(event) {
                return event.type.includes('mouse') ? event.clientX : event.touches[0].clientX;
            }

            function dragStart(event) {
                if (event.type === 'mousedown' && event.button !== 0) return;

                if (autoplayTimer) clearInterval(autoplayTimer);

                if (currentIndex === 0) goToSlide(originalSlides.length, false);
                if (currentIndex >= allSlides.length - 1) goToSlide(1, false);
                track.offsetWidth;

                startX = getPositionX(event);
                currentX = startX;
                isDragging = true;
                isMoved = false;
                track.style.transition = 'none';
            }

            function dragMove(event) {
                if (!isDragging) return;

                if (event.type === 'mousemove' && event.buttons === 0) {
                    dragEnd();
                    return;
                }

                currentX = event.type.includes('mouse') ? event.clientX : event.touches[0].clientX;
                const diffX = currentX - startX;

                if (Math.abs(diffX) > 10) {
                    isMoved = true;
                }

                if (event.type === 'touchmove' && Math.abs(diffX) > 10 && event.cancelable) {
                    event.preventDefault();
                }

                const trackWidth = wrapper.offsetWidth;
                const currentPosition = -currentIndex * trackWidth;
                track.style.transform = `translateX(${currentPosition + diffX}px)`;
            }

            function dragEnd() {
                if (!isDragging) return;
                isDragging = false;

                const diffX = currentX - startX;

                if (diffX < -50) {
                    goToSlide(currentIndex + 1);
                } else if (diffX > 50) {
                    goToSlide(currentIndex - 1);
                } else {
                    goToSlide(currentIndex);
                }

                setTimeout(() => { isMoved = false; }, 50);
                startAutoplay();
            }

            container.addEventListener('mousedown', dragStart);
            container.addEventListener('mousemove', dragMove);
            container.addEventListener('mouseup', dragEnd);
            container.addEventListener('mouseleave', dragEnd);

            container.addEventListener('touchstart', dragStart, { passive: true });
            container.addEventListener('touchmove', dragMove, { passive: false });
            container.addEventListener('touchend', dragEnd);

            startAutoplay();
        });

        return this;
    }
}
